import { shellStringResources } from '../../Resources/ShellStringResources';
import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Named } from '../base/named';
import { AdditionalColumn } from '../pipeline/additional-column';

@Metamodel.model({
    name: 'copysource',
    abstract: true,
    referable: false
})
export class CopySource extends Named {
    public static readonly MODEL: IModel;
    public static readonly ADDITIONAL_COLUMNS: IAttribute;

    @Metamodel.attribute({
        display: shellStringResources.CopySource_AdditionalColumns,
        accepts: ['Array'],
        association: 'ADDITIONAL_COLUMNS',
        templatable: true,
        defaultValue: []
    })
    public additionalColumns?: AdditionalColumn[] = [];
}

export interface ICopySourceWithPartitionOption extends CopySource {
    partitionOption: string;
}
